import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { A } from '../../common';
import { useGbAppLogin, useUserInfo } from '../../../hooks';

function LeaveSuccess() {
  const { t } = useTranslation();
  const { setInfo } = useUserInfo();
  const { guestLogin } = useGbAppLogin();

  const handlePage = useCallback(() => {
    localStorage.removeItem("access.email");
    localStorage.removeItem('access.token');
    localStorage.removeItem('access.starToken');
    setInfo({ learnerId: null })
    guestLogin();
  }, [])
  return (
    <div className="layout-def with_bottom_area bg_gray bg_my withdraw_done gb">
      <div className="header">
        <div className="inner">
          <div className="headerBox center">
            <div className="headerBox_head">
              <h1 className="tit">{t("MY_03_05.msg001")}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="inner">
          <div className="center_wrap">
            <div className="pic_wrap">
              <div className="pic">
                <img src="./static/images/common/img_my_03_06@2x.png" alt="" />
              </div>
            </div>
            <div className="noti_wrap">
              <div className="noti1">{t("MY_03_06.msg001")}</div>
              <div className="noti2" dangerouslySetInnerHTML={{ __html: t("MY_03_06.msg002")}}/>
            </div>
          </div>
          <div className="bottom_wrap btn_wrap static">
            <A onClick={handlePage} className="btn btn-blue">{t("MY_03_06.msg004")}</A>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeaveSuccess;